module.exports = __webpack_public_path__ + "static/media/titan.1256107d.svg";